var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { getTextAlignment } from '../../helpers/styles';
var StyledTh = styled.th(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var StyledTd = styled.th.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: ", ";\n  border-left-color: ", ";\n  border-top-color: ", ";\n  ", "\n"], ["\n  border: ", ";\n  border-left-color: ",
    ";\n  border-top-color: ",
    ";\n  ",
    "\n"])), function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.border;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.borderLeft;
}, function (_a) {
    var windowTheme = _a.windowTheme;
    return windowTheme.dataGrid.table.thead.tr.th.borderTop;
}, function (_a) {
    var attributes = _a.attributes;
    return attributes && getTextAlignment(attributes.textAlignment);
});
var Column = function (props) {
    var attributes = props.attributes, notHeader = props.notHeader, className = props.className, restProps = __rest(props, ["attributes", "notHeader", "className"]), _a = attributes || '', text = _a.text, icon = _a.icon;
    console.log({ attributes: attributes, notHeader: notHeader });
    return icon ? (React.createElement(StyledTd, __assign({}, restProps, { attributes: attributes }),
        React.createElement("img", { height: 14, width: 14, src: require("../../assets/icons/" + icon.replace(/:/g, '') + ".png") }))) : notHeader ? (React.createElement(StyledTd, __assign({}, restProps, { attributes: attributes }), text)) : (React.createElement(StyledTh, null, text));
};
export default Column;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map